import { render } from "./UserBmi.vue?vue&type=template&id=879c44ba&scoped=true"
import script from "./UserBmi.vue?vue&type=script&lang=js"
export * from "./UserBmi.vue?vue&type=script&lang=js"

import "./UserBmi.vue?vue&type=style&index=0&id=879c44ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-879c44ba"]])

export default __exports__